module.exports = require("lodash/isFinite");